module.exports = __webpack_public_path__ + "static/media/20210109_212101_066_IMG_1741.3e271085.jpg";